<script lang="ts">
	import IconButton from './buttons/IconButton.svelte';
	import { fade } from 'svelte/transition';
	import { _ } from 'svelte-i18n';

	interface Props {
		right?: any;
		isDeleteAble?: boolean;
		children?: import('svelte').Snippet<[any]>;
		onDelete: () => void;
	}

	let { right = -16, isDeleteAble = true, children, onDelete }: Props = $props();
	let showDelete = $state(false);
</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<div
	class="relative"
	onmouseleave={() => (showDelete = false)}
	onmouseenter={() => (showDelete = true)}
>
	{@render children?.({ showDelete })}

	{#if showDelete && isDeleteAble}
		<div
			in:fade={{ duration: 800 }}
			style="width: 32px; height: 32px; top: 0; bottom: 0; right: {right}px;"
			class="absolute rounded-full m-auto bg-white text-primary-200 flex items-center justify-center"
		>
			<IconButton
				onClick={onDelete}
				iconName="trash"
				mainColor="error"
				size={'small'}
				hoverText={$_('general.lbl_delete')}
			/>
		</div>
	{/if}
</div>
